const comments = [
  {
    name: '影迷小明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Asian%20man%20with%20friendly%20expression%2C%20clean%20white%20background%2C%20corporate%20style%2C%20warm%20natural%20lighting&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '用了半年多了，片源真的很全，基本上想看的电影都能找到。播放也很流畅，1080P画质在电视上看效果特别好。推荐给了很多朋友，大家都觉得比那些收费平台还好用。',
    time: '3天前',
    rating: 5,
  },
  {
    name: '追剧达人',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Asian%20woman%20with%20warm%20smile%2C%20clean%20white%20background%2C%20modern%20corporate%20style%2C%20soft%20natural%20lighting&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '作为一个重度追剧用户，91电影视频的更新速度真的没话说。热播剧基本上当天就能看到，而且不用注册直接就能看，太方便了。唯一的建议是希望能增加一个追剧提醒功能。',
    time: '5天前',
    rating: 4,
  },
  {
    name: '电影老炮',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20middle-aged%20Asian%20man%20with%20thoughtful%20expression%2C%20clean%20white%20background%2C%20artistic%20style%2C%20warm%20lighting&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '从最初的测试版就在用了，见证了平台一步步的成长。现在每天的更新量、播放画质和稳定性都比以前好太多了。特别喜欢那个专题合集的功能，按类型找片很方便。希望继续保持免费，会一直支持下去。',
    time: '1周前',
    rating: 5,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3 whitespace-nowrap">观众热评</span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">观众热评 · 真实反馈</h2>
          <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">来自真实用户的观影体验分享</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5 max-w-5xl mx-auto">
          {comments.map((item, i) => (
            <div key={i} className="p-5 md:p-6 rounded-2xl bg-background-50 border border-background-200/70">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img src={item.avatar} alt={item.name} className="w-full h-full object-cover" />
                </div>
                <div>
                  <h3 className="font-semibold text-sm text-foreground-900 whitespace-nowrap">{item.name}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                </div>
              </div>
              <div className="flex gap-0.5 mb-3">
                {Array.from({ length: 5 }).map((_, ri) => (
                  <span key={ri} className={`w-3.5 h-3.5 flex items-center justify-center ${ri < item.rating ? 'text-accent-500' : 'text-foreground-300'}`}>
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}